import {Component, Injector, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {BasePropostaComponent} from '../base-proposta';
import {ToastrService} from 'ngx-toastr';
import {AppComponent} from '../../../app.component';
import {CupomService} from '../../../core/services/cupom.service';
import {PropostaService} from '../../../core/services/proposta.service';
import {Meta, Title} from '@angular/platform-browser';
import {ProdutoService} from '../../../core/services/produto.service';
import {RdService} from '../../../core/services/rd.service';
import {CepService} from '../../../core/services/cep.service';
import {CategoriaPlanoService} from '../../../core/services/categoria_plano.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-seguranca',
    templateUrl: './seguranca.component.html',
    styleUrls: ['./seguranca.component.sass']
})
export class SegurancaComponent extends BasePropostaComponent implements OnInit {
    tipoOcupacao: string;
    renda: string;

    constructor(
        protected injector: Injector,
        public cupomService: CupomService,
        public propostaService: PropostaService,
        public router: Router,
        public toast: ToastrService,
        public rdService: RdService,
        public cepService: CepService,
        public categoriaPlanoService: CategoriaPlanoService,
        public appComponent: AppComponent,
        public titleService: Title,
        public meta: Meta,
        public produtoService: ProdutoService,
        public deviceService: DeviceDetectorService,
        ) {
        super(injector);
    }

    async ngOnInit() {
        await this.inOnInit();
        this.carregarValoresLocalStorage();
    }

    carregarValoresLocalStorage() {
        const proposta = this.getPropostaParaStorage();

        if (!proposta) {
            return;
        }

        if (proposta.faixaRenda && proposta.faixaRenda.id) {
            this.renda = proposta.faixaRenda.id;
        }

        if (proposta.tipoVinculoEmpregaticio) {
            this.tipoOcupacao = proposta.tipoVinculoEmpregaticio;
        }
    }

    async goToConfirmacao() {
        if (this.tipoOcupacao && this.renda) {
            const query = {
                faixaRenda: {
                    id: this.renda
                },
                tipoVinculoEmpregaticio: this.tipoOcupacao === 'P1' ? 'P' : this.tipoOcupacao
            };

            const result = await this.propostaService.cadastroDadosProfissionais(query);

            if (result.status === 200 || result.status === 201) {
                // await this.rdService.carrinhoSucessoCompra(
                //     this.emailCliente,
                //     this.getDescricaoRenda(this.renda),
                //     this.getDescricaoVinculo(query.tipoVinculoEmpregaticio)
                // );
                if (result.status === 200 || result.status === 201) {
                    const queryRD = {
                        event_type: 'CONVERSION',
                        event_family: 'CDP',
                        payload: {
                            conversion_identifier: 'Carrinho_Site_Passo_3',
                            email: this.emailCliente,
                            cf_renda_aproximada: this.renda,
                            cf_codtipovinculo: this.tipoOcupacao === 'P1' ? 'P' : this.tipoOcupacao
                        }
                    };

                    this.rdService.updateEventByIdentifier(queryRD);
                    query.tipoVinculoEmpregaticio = this.tipoOcupacao;
                    this.addPropostaParaStorage(query);

                    await this.router.navigate(['confirmacao']);
                } else {
                    this.toast.error('Ocorreu um erro ao processar a requisição', '', {
                        timeOut: 5000
                    });
                }
            }
            if (this.tipoOcupacao === undefined) {
                this.toast.error(
                    'Selecione um tipo de ocupação',
                    '',
                    {timeOut: 5000}
                );
                return;
            }
            if (this.renda === undefined) {
                this.toast.error(
                    'Selecione uma renda',
                    '',
                    {timeOut: 5000}
                );
                return;
            }
        }
    }

    private getDescricaoRenda(renda: string) {
        let result = '';
        switch (renda.toString()) {
            case '11':
                result = 'De R$ 1.500,01 a R$ 2.500,00';
                break;
            case '12':
                result = 'De R$ 2.500,01 a R$ 3.500,00';
                break;
            case '13':
                result = 'De R$ 3.500,01 a R$ 5.000,00';
                break;
            case '14':
                result = 'De R$ 5.000,01 a R$ 10.000,00';
                break;
            case '15':
                result = 'De R$ 10.000,01 a R$ 20.000,00';
                break;
            case '16':
                result = 'Acima de 20.000,00';
                break;
            default:
                result = renda;
        }
        return result;
    }

    private getDescricaoVinculo(tipoVinculoEmpregaticio: string) {
        let result = '';
        switch (tipoVinculoEmpregaticio) {
            case 'S':
                result = 'Funcionário Público';
                break;
            case 'P':
                result = 'Aposentado';
                break;
            case 'P1':
                result = 'Pensionista';
                break;
            case 'C':
                result = 'Funcionário Privado';
                break;
            case 'A':
                result = 'Autônomo';
                break;
            case 'E':
                result = 'Empresário';
                break;
            default:
                result = tipoVinculoEmpregaticio;
                break;
        }
        return result;
    }
}
